var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoGithub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo_Plus_Github",
    "data-name": "Logo/Plus/Github",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    "data-name": "Fill 4",
    d: "M10,0A10.129,10.129,0,0,0,0,10.253a10.235,10.235,0,0,0,6.839,9.728c.5.094.683-.222.683-.494,0-.243-.009-.888-.014-1.744-2.782.619-3.368-1.375-3.368-1.375a2.7,2.7,0,0,0-1.111-1.5c-.908-.636.069-.623.069-.623A2.106,2.106,0,0,1,4.629,15.3a2.1,2.1,0,0,0,2.91.852,2.213,2.213,0,0,1,.635-1.37c-2.22-.259-4.555-1.139-4.555-5.068A4.019,4.019,0,0,1,4.649,6.966a3.77,3.77,0,0,1,.1-2.713S5.586,3.977,7.5,5.3a9.241,9.241,0,0,1,5.007,0c1.909-1.327,2.747-1.051,2.747-1.051a3.771,3.771,0,0,1,.1,2.713,4.012,4.012,0,0,1,1.028,2.751c0,3.939-2.338,4.806-4.566,5.059a2.483,2.483,0,0,1,.678,1.9c0,1.37-.012,2.476-.012,2.812,0,.274.18.594.688.493A10.237,10.237,0,0,0,20,10.253,10.13,10.13,0,0,0,10,0",
    fill: "#161514"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGithub);
export default __webpack_public_path__ + "static/media/logo-github.0c984e3e1ef61a9608104313aea068b0.svg";
export { ForwardRef as ReactComponent };